/**
 * Converte erros técnicos (JSON Evolution, HTTP, etc.) em texto legível para o utilizador.
 */

function parseJsonMaybe(text) {
  const t = String(text || '').trim();
  if (!t.startsWith('{') && !t.startsWith('[')) return null;
  try {
    return JSON.parse(t);
  } catch {
    return null;
  }
}

function evolutionExistsFalse(obj) {
  if (!obj || typeof obj !== 'object') return false;
  const resp = obj.response && typeof obj.response === 'object' ? obj.response : obj;
  const msgs = resp?.message;
  if (Array.isArray(msgs)) {
    return msgs.some((m) => m && typeof m === 'object' && m.exists === false);
  }
  return false;
}

function humanizeObject(obj) {
  if (evolutionExistsFalse(obj)) {
    return (
      'Este número não foi encontrado no WhatsApp. ' +
      'Confira o DDD (2 dígitos) e o celular com o 9. Ex.: (69) 98125-3092.'
    );
  }
  const blob = JSON.stringify(obj || {}).toLowerCase();
  if (blob.includes('rate-overlimit') || blob.includes('rate_overlimit') || (blob.includes('overlimit') && blob.includes('rate'))) {
    return (
      'WhatsApp pediu pausa (muitos pedidos seguidos). Aguarde cerca de 1 minuto e tente de novo. ' +
      'Continuar a enviar agora piora o bloqueio.'
    );
  }
  if (typeof obj.message === 'string' && obj.message.trim()) return obj.message.trim();
  if (typeof obj.detail === 'string' && obj.detail.trim()) return obj.detail.trim();
  if (typeof obj.error === 'string' && obj.error.trim() && obj.error !== 'Bad Request') {
    return obj.error.trim();
  }
  if (Array.isArray(obj)) {
    const parts = obj
      .map((e) => (e && typeof e.msg === 'string' ? humanizeText(e.msg) : null))
      .filter(Boolean);
    return [...new Set(parts)].join(' ');
  }
  return '';
}

function humanizeText(text) {
  let t = String(text || '').trim();
  if (!t) return '';

  const lower = t.toLowerCase();
  if (lower.startsWith('erro no envio:')) {
    t = t.slice('erro no envio:'.length).trim();
  }

  if (
    lower.includes('valid integer') ||
    lower.includes('unable to parse string as an integer') ||
    lower.includes('input should be a valid integer')
  ) {
    return 'Identificador inválido. Atualize a página e tente novamente.';
  }

  const compact = t.toLowerCase().replace(/\s/g, '');
  if (compact.includes('"exists":false') || compact.includes("'exists':false")) {
    return (
      'Este número não foi encontrado no WhatsApp. ' +
      'Confira o DDD (2 dígitos) e o celular com o 9. Ex.: (69) 98125-3092.'
    );
  }
  if (compact.includes('onwhatsapp')) {
    return (
      'WhatsApp indisponível nesta sessão. ' +
      'Vá em Conexões, reconecte a instância (QR) e tente enviar de novo.'
    );
  }
  if (lower.includes('session not connected') || lower.includes('not connected')) {
    return 'WhatsApp desconectado. Reconecte em Conexões e tente novamente.';
  }
  if (
    lower.includes('rate-overlimit') ||
    lower.includes('rate_overlimit') ||
    (lower.includes('overlimit') && lower.includes('rate'))
  ) {
    return (
      'WhatsApp pediu pausa (muitos pedidos seguidos). Aguarde cerca de 1 minuto e tente de novo. ' +
      'Continuar a enviar agora piora o bloqueio.'
    );
  }

  const parsed = parseJsonMaybe(t);
  if (parsed) {
    const friendly = humanizeObject(parsed);
    if (friendly) return friendly;
    return 'Não foi possível concluir a operação. Verifique os dados e tente novamente.';
  }

  if (t.length > 220 && (t.includes('{') || t.includes('['))) {
    return 'Não foi possível concluir a operação. Verifique os dados e tente novamente.';
  }

  return t;
}

/** @param {unknown} raw */
export function formatNotifyMessage(raw) {
  if (raw == null) return '';
  if (typeof raw === 'string') return humanizeText(raw);
  if (typeof raw === 'number' || typeof raw === 'boolean') return String(raw);
  if (Array.isArray(raw)) {
    const parts = raw
      .map((e) => {
        if (!e) return '';
        if (typeof e === 'string') return humanizeText(e);
        if (typeof e.msg === 'string') return humanizeText(e.msg);
        return '';
      })
      .filter(Boolean);
    return [...new Set(parts)].join(' ');
  }
  if (typeof raw === 'object') {
    const fromObj = humanizeObject(raw);
    if (fromObj) return fromObj;
    if (typeof raw.message === 'string') return humanizeText(raw.message);
    if (typeof raw.msg === 'string') return humanizeText(raw.msg);
    try {
      return humanizeText(JSON.stringify(raw));
    } catch {
      return 'Ocorreu um erro inesperado.';
    }
  }
  return String(raw);
}

export default formatNotifyMessage;
